import React, { useState,useEffect } from "react";
import FormInput from "../FormInput/FormInput";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { EmptyingAllInputs, Notification } from "../../utils";
import { useDispatch, useSelector } from "react-redux";
import {
  sendOtpEmailRegister,
  clearErrors,
} from "../../redux/actions/userActions";
import Loader from "../Loader/Loader";

const Login = () => {
  const { error, loading, response, success } = useSelector(
    (state) => state.user
  );
  const dispatch = useDispatch();
  const [type, setType] = useState(true);

  const changeType = () => {
    setType(!type);
    EmptyingAllInputs();
  };

  const [form, setForm] = useState({
    email: "",
    phoneNumber: "",
  });

  const emailSchema = yup.object().shape({
    email: yup
      .string()
      .email("Field should contain a valid e-mail")
      .required("E-mail is required"),
  });

  const phoneSchema = yup.object().shape({
    phoneNumber: yup.string().required("Phone Number is required"),
  });

  const {
    register,
    setValue,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(type ? emailSchema : phoneSchema),
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({
      ...form,
      [name]: value,
    });
    setValue(name, value, { shouldValidate: true });
  };

  const onSubmit = (data) => {
    console.log(data);
    if(type){
      dispatch(sendOtpEmailRegister(data))
    }
    dispatch(sendOtpEmailRegister(data));
    reset();
    EmptyingAllInputs();
  };

  useEffect(() => {
    Notification(success, error, response);

    dispatch(clearErrors());
  }, [dispatch, error, loading, response, success]);

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="single__account">
          <div className="col-12">
            <FormInput
              tag={"input"}
              type={type ? "email" : "telephone"}
              name={type ? "email" : "phoneNumber"}
              placeholder={
                type ? "Enter your email" : "Enter your phone number"
              }
              onChange={handleChange}
              value={form[type ? "email" : "phoneNumber"]}
              error={errors[type ? "email" : "phoneNumber"]}
              register={register}
            />
          </div>

          <p className="forget__pass login-password-p" onClick={changeType}>
            {!type
              ? "Login with your Email Address"
              : "Login with your Phone Number"}
          </p>
          <Link
            className="forget__pass"
            to={process.env.PUBLIC_URL + "/forgot-password"}
          >
            Lost your password?
          </Link>
          <button className="account__btn" type="submit">
            Login
          </button>
        </div>
      </form>
    </>
  );
};

export default Login;
